import { Text, ReactTable, Box } from '@wegroup/design-system';
import { format } from 'date-fns';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from 'react-table';
import { Accident } from '../../../../types/CompanyScanTypes';
import TableActionsMenu from '../common/TableActionsMenu';
import TableFiller from '../common/TableFiller';

interface Props {
  accidents: Accident[];
  onEdit: (accident: Accident) => void;
  onRemove: (index: number) => void;
}

const AccidentsTable: React.FC<React.PropsWithChildren<Props>> = ({
  accidents,
  onEdit,
  onRemove,
}) => {
  const { t } = useTranslation();

  const renderTitleCell = (cell: Cell) => {
    return <Text color="text.gray">Accident {cell.row.index + 1}</Text>;
  };

  const renderDateCell = (cell: Cell) => {
    const { date } = cell?.row?.original as Accident;

    const formattedDate = format(new Date(date), `yyyy-MM-dd`);
    return <Text color="text.gray">{formattedDate}</Text>;
  };

  const renderAtFaultCell = (cell: Cell) => {
    const { at_fault } = cell?.row?.original as Accident;

    return <Text color="text.gray">{at_fault ? 'Yes' : 'No'}</Text>;
  };

  const renderActionMenuCell = (cell: Cell) => {
    const accident = cell?.row?.original as Accident;
    const index = cell?.row?.index;

    return (
      <TableActionsMenu
        onEdit={() => onEdit(accident)}
        onRemove={() => onRemove(index)}
      />
    );
  };

  const columns = useMemo(
    () => [
      {
        accessor: 'number',
        Cell: renderTitleCell,
        disableSortBy: true,
        isSticky: true,
      },
      {
        Header: t('Date'),
        accessor: 'date',
        Cell: renderDateCell,
      },
      {
        Header: t('At fault'),
        accessor: 'at_fault',
        Cell: renderAtFaultCell,
        disableSortBy: true,
      },
      {
        Header: t('ACTIONS'),
        id: 'actions',
        Cell: renderActionMenuCell,
        disableSortBy: true,
      },
    ],
    [accidents],
  );

  return (
    <Box>
      <ReactTable
        data={accidents}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        columns={columns as any}
      />
      {accidents.length === 0 && (
        <TableFiller>
          <Text>{t('FLOWS_COMPANY-SCAN_ACCIDENT-INPUT_EMPTY-TABLE')}</Text>
        </TableFiller>
      )}
    </Box>
  );
};

export default AccidentsTable;
